import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import React, { ComponentProps } from 'react'
import { StepInfo, StepRoot } from './Step.styles'

type StepOwnProps = ComponentProps<typeof StepRoot>
export type StepProps = StepOwnProps & {
  title: string
  keyValuePairs: { key: string; values: string[]; links?: string[] }[]
}

export const Step = ({ title, keyValuePairs, ...rest }: StepProps) => {
  return (
    <StepRoot {...rest}>
      <Stack direction="column">
        <Text className="step-title" size="h5" display="block" weight="medium">
          {title}
        </Text>
        {keyValuePairs.map(({ key, values, links }) => (
          <StepInfo key={key}>
            <Stack>
              <Text>{key}</Text>
              <div>
                {values.map((value, index) => (
                  <Text
                    as={links?.[index] ? 'a' : 'span'}
                    target="_blank"
                    href={links?.[index]}
                    key={value}
                    weight="medium"
                  >
                    {value}
                  </Text>
                ))}
              </div>
            </Stack>
          </StepInfo>
        ))}
      </Stack>
    </StepRoot>
  )
}

Step.displayName = 'Step'
